import { render } from "./EtatNombreProduitVendu.vue?vue&type=template&id=144ad1e9&ts=true"
import script from "./EtatNombreProduitVendu.vue?vue&type=script&lang=ts"
export * from "./EtatNombreProduitVendu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__